import { render, staticRenderFns } from "./GDP-and-growth-rate.vue?vue&type=template&id=4e5b4422&scoped=true"
import script from "./GDP-and-growth-rate.vue?vue&type=script&lang=js"
export * from "./GDP-and-growth-rate.vue?vue&type=script&lang=js"
import style0 from "./GDP-and-growth-rate.vue?vue&type=style&index=0&id=4e5b4422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b4422",
  null
  
)

export default component.exports